import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { STYLE_OPTIONS } from 'src/constants';

const transitionGuideBannerStyles = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
    padding: '16px 24px',
    backgroundColor: '#f3f0ff',
    borderLeft: '4px solid #764ba2',
    borderRadius: '4px',
    fontFamily: STYLE_OPTIONS.FONT_FAMILY,
  },

  textContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: '1 1 auto',
  },

  icon: {
    color: '#764ba2',
    fontSize: '20px',
  },

  label: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#4a4a4a',
  },

  viewButton: {
    color: '#764ba2',
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '14px',
    padding: '6px 16px',
    borderRadius: '20px',
    border: '1px solid #764ba2',

    '&:hover': {
      backgroundColor: 'rgba(118, 75, 162, 0.08)',
    },
  },

  externalIcon: {
    fontSize: '16px',
    marginLeft: '4px',
  },
};

function TransitionGuideBanner({
  classes,
  onOpenGuide,
}) {
  return (
    <Box className={classes.banner}>
      <Box className={classes.textContent}>
        <MenuBookIcon className={classes.icon} />
        <Typography className={classes.label}>
          Switching from PB? Read the Transition Guide
        </Typography>
      </Box>
      <Button
        className={classes.viewButton}
        onClick={onOpenGuide}
        size="small"
      >
        View Guide
        <OpenInNewIcon className={classes.externalIcon} />
      </Button>
    </Box>
  );
}

TransitionGuideBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  onOpenGuide: PropTypes.func.isRequired,
};

export default withStyles(
  TransitionGuideBanner,
  transitionGuideBannerStyles,
);
